import React, { useEffect, useState } from 'react';

import { MAX_NOTE_NAME_LENGTH } from 'utils/constants';
import APModal from 'components/Modal/APModal';
import InputField from 'components/FormFields/InputField';
import APFormGroup from 'components/FormFields/APFormGroup';
import FormSelect from 'components/FormFields/FormSelect';

const SaveTemplateModal = ({ note, templateModalOpened, setTemplateModalOpened, saveTemplate, templateFolders }) => {
  const [templateName, setTemplateName] = useState(note.title);
  const [folder, setFolder] = useState('');
  const [folders, setFolders] = useState([]);
  const [newFolderName, setNewFolderName] = useState('');
  const [showNewFolderName, setShowNewFolderName] = useState(false);
  const [error, setError] = useState('');

  const fieldsCompleted = () => {
    return templateName && ((showNewFolderName && newFolderName) || !showNewFolderName) && folder;
  };

  useEffect(() => {
    if (fieldsCompleted() && error) {
      setError('');
    }
  }, [templateName, showNewFolderName, newFolderName, folder]);

  useEffect(() => {
    setFolders([...templateFolders, {
      id: -1,
      name: 'Create new +',
      disabled: true,
    }]);
  }, [templateFolders]);

  const onChangeFolder = (value) => {
    if (value === '-1') {
      setShowNewFolderName(true);
    } else {
      setShowNewFolderName(false);
      setError('');
    }
    setFolder(value);
  };

  const onSave = () => {
    if (fieldsCompleted()) {
      saveTemplate({
        name: templateName,
        title: templateName,
        noteHtml: note.noteHtml,
        noteJson: note.noteJson,
        plannerOnly: note.plannerOnly,
        clientReadOnly: note.clientReadOnly,
        noteTemplateFolderId: folder === '-1' ? null : folder,
        templateFolderName: newFolderName,
        showBrandingHeader: note.showBrandingHeader,
        isFileUpload: note.isFileUpload,
        noteFileId: note.noteFileId,
        imageKey: note.image?.key,
        url: note.url,
      });
      setTemplateModalOpened(false);
    } else {
      setError('Please complete all required fields above.');
    }
  };

  const onCancel = () => {
    setTemplateModalOpened(false);
  };

  const nameTemplateOnChange = (event) => {
    setTemplateName(event.target.value);
  };

  const newNameFolderOnChange = (event) => {
    setNewFolderName(event.target.value);
  };

  const modalActions = [{ onClick: onSave, title: 'Save' }];

  const modalContent = (
    <>
      <APFormGroup grid={false}>
        <InputField
          name="name_template"
          label="Name template"
          defaultValue={templateName}
          onChange={nameTemplateOnChange}
          onPointerDown={(e) => e.stopPropagation()}
          maxLength={MAX_NOTE_NAME_LENGTH}
          showError={!templateName}
          required
        />
        <FormSelect
          onChange={(e) => {
            onChangeFolder(e.target.value);
          }}
          value={folder}
          name="Folder"
          className="template-folder-select"
          scrollLockOnOpen={false}
          responsive={false}
          required
          footer={(
            <button
              onClick={() => {
                onChangeFolder('-1');
              }}
              className="button--unstyled gold--large"
            >
              Create New +
            </button>
          )}
        >
          {folders.map(item => renderOption(item.id, item.name, item.disabled ? { disabled: true } : undefined))}
        </FormSelect>
        {showNewFolderName && (
          <InputField
            name="new_folder_name"
            label="Name Folder"
            defaultValue={newFolderName}
            onChange={newNameFolderOnChange}
            showError={!newFolderName}
            required
          />
        )}
      </APFormGroup>
    </>
  );

  return renderModal(
    templateModalOpened,
    'Save as template.',
    'save-as-template',
    modalActions,
    onCancel,
    modalContent,
    error,
  );
};

export default SaveTemplateModal;

const renderOption = (value, label, restProps) => {
  return (
    <option
      key={`move-to-${value}`}
      value={value}
      {...restProps}
    >
      {label}
    </option>
  );
};

const renderModal = (
  modalOpened,
  title,
  name,
  modalActions,
  onClose,
  modalContent,
  error,
) => {

  const renderModalActions = () => {
    return (
      <>
        {modalActions.map((item, index) => (
          <button
            className="button"
            onClick={item.onClick}
            key={index}
          >
            {item.title}
          </button>
        ))}
      </>
    );
  };

  return (
    <APModal
      open={modalOpened}
      title={title}
      name={name}
      onClose={onClose}
      actions={renderModalActions()}
    >
      {modalContent}
      <section className='note-error'>
        {error}
      </section>
    </APModal>
  );
};
